import { useDispatch, useSelector } from "react-redux";
import TableWrapper from "../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../Components/Common/CommonHeader/CommonHeader";
import { btnAccessChecker, checkButtonAccess, getOrgId } from "../../Utils/CommonUtils";
import useAgMemberColumns from "./Hooks/useAgMemberColumns";
import NewAgMemberModal from "./NewAgMemberModal";
import { useEffect } from "react";
import {
  setAgMemberData,
  setAgMemberFilterForm,
  setAgMemberSorting,
} from "../../slices/agMember/agMemberSlice";
import {
  getFilteredDataWithTabs,
  getListingByOrgId,
} from "../../Utils/CommonService";
import AffinityGroupFilter from "../AG/AffinityGroup/AffinityGroupFilter";
import { getDropdownListOfRM } from "./AgMemberService";
import AgMemberFilter from "./AgMemberFilter";

const AffinityGroupList = () => {
  const { agMemberColumns } = useAgMemberColumns();
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);
  const agMemberData = useSelector((state) => state.agMember.agMemberData);
  const selector = useSelector((state) => state.moduleaccesstree);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  // const organizationId = getOrgId();
  const agMemberFieldJson = useSelector(
    (state) => state.agMember.agMemberFieldJson
  );
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector((state) => state.agMember.filter.filterApi);
  const filterForm = useSelector((state) => state.agMember.filter.form);
  const sortColumn = useSelector((state) => state.agMember.sorting.column);
  const sortOrder = useSelector((state) => state.agMember.sorting.order);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);

  const storedUser = JSON.parse(localStorage.getItem("selectedUser"));
  const enterpriseid = localStorage.getItem("enterpriseid");
  const userid = localStorage.getItem("userId");
  const selectedUser = useSelector((state) => state.header.selectedUser);

  useEffect(() => {
    if (storedUser.owner_id) {
      getDropdownListOfRM(
        storedUser.owner_id,
        selectedUser.organizationid,
        agMemberFieldJson
      );
    }
  }, [storedUser.owner_id]);

  useEffect(() => {
    dispatch(setAgMemberFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "AGM_MEM")}
        buttonTitle={"New Member"}
        filterComponent={<AgMemberFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={agMemberColumns}
          data={agMemberData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"AGM"}
          filterApiListEntity={"AGM"}
          filterApiFunction={setAgMemberData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setAgMemberSorting}
          enterpriseId={enterpriseid}
          userId={userid}
          organizationId={selectedUser.organizationid}
        />
      </div>

      {(modalShow || editShow) && <NewAgMemberModal />}
    </div>
  );
};

export default AffinityGroupList;
